import { BulkUploadDownloadResponse, BulkUploadListResponse } from 'pages/Dashboard/types/bulkUpload.types';
import { QueryFunctionContext } from 'react-query';
import { bulkUploadUrls } from 'utils/apiUrls';
import { HttpType } from 'utils/http';

export const fetchBulkUploadList = (method: HttpType['get']) => function async({ queryKey }: QueryFunctionContext): Promise<BulkUploadListResponse> {
  const [, providerId] = queryKey;
  return method(bulkUploadUrls.listBulkUploads.apiUrl(providerId as string));
};

// Now uses POST and expects a payload with file_key
export const fetchBulkUploadDownload = (method: HttpType['post']) => async ({ queryKey }: QueryFunctionContext): Promise<BulkUploadDownloadResponse> => {
  const [, providerId, fileKey] = queryKey;
  return method(
    bulkUploadUrls.downloadBulkUpload.apiUrl(
        providerId as string,
    ),
    { file_key: fileKey as string },
  );
};
